import { backofficeApi } from '@kardume/services';
import type { MerchantImageTarget } from '@kardume/types';
import type { ImageUploadPayload } from '@kardume/ui';

/**
 * Uploads a picked image to the backoffice merchant image endpoint and resolves
 * to its public URL - the `onUpload` contract of `ImageUpload`.
 *
 * Mirrors `apps/admin/src/utils/imageUpload.ts`, but the endpoint is scoped by
 * merchant id: the backoffice operator acts on someone else's store, so the
 * target store cannot be inferred from the token as it is in the merchant panel.
 */
export const uploadMerchantImage =
  (merchantId: string, target: MerchantImageTarget) =>
  async (payload: ImageUploadPayload): Promise<string> => {
    const res = await backofficeApi.uploadMerchantImage(merchantId, {
      image: { base64: payload.base64, contentType: payload.contentType, extension: payload.extension },
      target,
    });
    return res.url;
  };
